<template>
    <div class="templete_box">
        <div class="templete clearfix">
            <div class="clearfix">
                <el-button class="funcPublicBtn funcPublicBtnChecked" @click="dialogVisible=!dialogVisible">清空数据</el-button>
            </div>
        </div>
        <el-dialog v-dialog-drag :visible.sync="dialogVisible" class="eldialog eldialogLine" width="500px" :modal="false" title="清空数据" custom-class="full_dialog">
            <el-form class="dialogFormB clearfix">
                <div class="eldialogFormBox">
                    <el-form-item label="密码：">
                        <el-input v-model="password" type="password"></el-input>
                    </el-form-item>
                </div>
            </el-form>
            <div class="dialogBtnList clearfix">
                <el-button class="dialogBtn funcPublicBtn" @click="dialogVisible=!dialogVisible">取消</el-button>
                <el-button  class="publicBtn dialogBtn" @click="confirm">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    export default {
        data(){
            return{
                dialogVisible:false,
                password:""
            }
        },
        methods:{
            confirm(){
                this.$confirm('是否确认清空数据?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.postFunc("/erp/system.data.clear",{password:this.password},()=>{
                        this.tip("清空成功","success")
                        this.dialogVisible=false;
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{});
            }
        },
        watch:{
            dialogVisible:function(val){
                if(!val){
                    this.password = "";
                }
            }
        }
    }
</script>
<style scoped lang="scss">
</style>
